export const getQuestionsList = (dictionary, type) => {
	if (type === "general_information") {
		const questionsDictionary = { ...dictionary["questions"] };
		const questionsFaq = { ...dictionary["faq"] };

		return [
			{
				category: questionsDictionary["general information"],
				list: [
					{
						question: questionsDictionary["who are you and why did you create BgRem"],
						answer: questionsFaq["answer"],
						active: false,
					},
					{
						question: questionsDictionary["why BgRem"],
						answer: questionsFaq["answer_why"],
						active: false,
					},
					{
						question: questionsDictionary["who can benefit from BgRem"],
						answer: questionsFaq["answer_who"],
						active: false,
					},
					{
						question: questionsDictionary["is it free to use"],
						answer: questionsFaq["answer_free"],
						active: false,
					},
					{
						question: questionsDictionary["which web browsers are supported by the service"],
						answer: questionsFaq["answers_browsers"],
						active: false,
					},
				],
			},
			{
				category: questionsDictionary["sign in and sign up"],
				list: [
					{
						question: questionsDictionary["how can I confirm my email address"],
						answer: questionsDictionary["how can I confirm my email address - answer"],
						active: false,
					},
					{
						question: questionsDictionary["i cant sign in"],
						answer: questionsDictionary["i cant sign in - answer"],
						active: false,
					},
					{
						question: questionsDictionary["i forgot my password"],
						answer: questionsDictionary["i forgot my password - answer"],
						active: false,
					},
				],
			},
			{
				category: questionsDictionary["plans and tariffs"],
				list: [
					{
						question: dictionary["page_pricing"]["faq"]["question_1"],
						answer: dictionary["page_pricing"]["faq"]["answer_1"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_2"],
						answer: dictionary["page_pricing"]["faq"]["answer_2"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_3"],
						answer: dictionary["page_pricing"]["faq"]["answer_3"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_4"],
						answer: dictionary["page_pricing"]["faq"]["answer_4"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_5"],
						answer: dictionary["page_pricing"]["faq"]["answer_5"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_6"],
						answer: dictionary["page_pricing"]["faq"]["answer_6"],
						active: false,
					},
					{
						question: dictionary["page_pricing"]["faq"]["question_7"],
						answer: dictionary["page_pricing"]["faq"]["answer_7"],
						active: false,
					},
				],
			},
			{
				category: questionsDictionary["contact details"],
				list: [
					{
						question: questionsDictionary["how can i contact you"],
						answer: questionsDictionary["how can i contact you - answer"],
						active: false,
					},
					{
						question: questionsDictionary["what is the fastest way I can reach you in case i need help"],
						answer: questionsFaq["answer_help"],
						active: false,
					},
				],
			},
			// {
			// 	category: "Text to image",
			// 	list: [
			// 		{
			// 			question: "What is “negative prompt”?",
			// 			answer:
			// 				"A negative prompt allows the user to specify what he doesn’t want to see in a generated picture. It may prevent generating specific things, styles, fix some image abnormalities, and greatly improve the quality. The most commonly used negative prompts are: worst quality, normal quality, low quality, low res, blurry, text, watermark, logo, horror, etc.",
			// 			active: false,
			// 			anchor: "negative",
			// 			images: [
			// 				{
			// 					id: 1,
			// 					text: "Prompt: Mystery forest",
			// 					src: "/faq/ml_faq/negative1.jpg",
			// 				},
			// 				{
			// 					id: 2,
			// 					text: "Prompt: Mystery forest. Negative prompt: fog, darkness",
			// 					src: "/faq/ml_faq/negative2.jpg",
			// 				},
			// 				{
			// 					id: 3,
			// 					text: "Prompt: Boy on the moon",
			// 					src: "/faq/ml_faq/negative3.jpg",
			// 				},
			// 				{
			// 					id: 4,
			// 					text: "Prompt: Boy on the moon. Negative prompt: Space suit",
			// 					src: "/faq/ml_faq/negative4.png",
			// 				},
			// 			],
			// 		},
			// 		{
			// 			question: "What is “seed”?",
			// 			answer:
			// 				"Every single generated image as a unique attribute called “Seed”. You don't need to come up with the number yourself because it is randomly generated when not specified. Controlling the seed can help you generate reproducible images, experiment with other parameters, or prompt variations. For example, you can type in a prompt “Boy in a T-shirt” and the seed of 538637855, and try just to change the color of a T-shirt in a prompt. The pictures will be almost identical despite the color of a T-shirt. Note: In case you want to control seed, you should type in about 9-digit number, so that it would be sufficient (like in example above).",
			// 			active: false,
			// 			anchor: "seed",
			// 			images: [
			// 				{
			// 					id: 1,
			// 					text: "Prompt: Boy in red T-shirt",
			// 					src: "/faq/ml_faq/seed1.jpg",
			// 				},
			// 				{
			// 					id: 2,
			// 					text: "Prompt: Boy in blue",
			// 					src: "/faq/ml_faq/seed2.jpg",
			// 				},
			// 				{
			// 					id: 3,
			// 					text: "Prompt: Boy in yellow T-shirt",
			// 					src: "/faq/ml_faq/seed3.jpg",
			// 				},
			// 				{
			// 					id: 4,
			// 					text: "Prompt: Boy in beige T-shirt",
			// 					src: "/faq/ml_faq/seed4.jpg",
			// 				},
			// 			],
			// 		},
			// 		{
			// 			question: "What is “steps”?",
			// 			answer:
			// 				"Generally speaking, the more steps you use, the better quality you'll achieve. But you shouldn't set steps as high as possible. First, we will introduce you the steps parameter in general. AI models are iterative processes – a repeated cycle that starts with a random noise generated from text input. Some noise is removed with each step, resulting in a higher-quality image over time. The repetition stops when the desired number of steps completes. Around 25 sampling steps are usually enough to achieve high-quality images. Using more may produce a slightly different picture, but not necessarily better quality. For example, compare 10 steps and 50 steps image generations:",
			// 			active: false,
			// 			anchor: "steps",
			// 			images: [
			// 				{
			// 					id: 1,
			// 					text: "Prompt: cosmic wolf. Steps: 10",
			// 					src: "/faq/ml_faq/steps1.jpg",
			// 				},
			// 				{
			// 					id: 2,
			// 					text: "Prompt: cosmic wolf. Steps: 25",
			// 					src: "/faq/ml_faq/steps2.jpg",
			// 				},
			// 				{
			// 					id: 3,
			// 					text: "Prompt: cosmic wolf. Steps: 50",
			// 					src: "/faq/ml_faq/steps3.jpg",
			// 				},
			// 			],
			// 		},
			// 		{
			// 			question: "What is “sampler”?",
			// 			answer:
			// 				"The sampler is responsible for carrying out the denoising steps. What is this? To produce an image, AI first generates a completely random image. The noise predictor then estimates the noise of the image. The predicted noise is subtracted from the image. This process is repeated a dozen times. In the end, you get a clean image. This denoising process is called sampling because AI generates a new sample image in each step. The method used in sampling is called the sampler. You can generate pictures of different quality and various degree of realism by choosing different samplers. Here you can see the examples for samplers introduced in BgRem, so that you can choose your favorite for your future generations:",
			// 			active: false,
			// 			anchor: "sampler",
			// 			images: [
			// 				{
			// 					id: 1,
			// 					text: "k_dpmpp_2m",
			// 					src: "/faq/ml_faq/sampler1.jpg",
			// 				},
			// 				{
			// 					id: 2,
			// 					text: "k_dpmpp_2s_a",
			// 					src: "/faq/ml_faq/sampler2.jpg",
			// 				},
			// 				{
			// 					id: 3,
			// 					text: "plms",
			// 					src: "/faq/ml_faq/sampler3.jpg",
			// 				},
			// 				{
			// 					id: 4,
			// 					text: "ddim",
			// 					src: "/faq/ml_faq/sampler4.jpg",
			// 				},
			// 				{
			// 					id: 5,
			// 					text: "k_dpm_fast",
			// 					src: "/faq/ml_faq/sampler5.jpg",
			// 				},
			// 				{
			// 					id: 6,
			// 					text: "k_dpm_adaptive",
			// 					src: "/faq/ml_faq/sampler6.jpg",
			// 				},
			// 				{
			// 					id: 7,
			// 					text: "k_lms",
			// 					src: "/faq/ml_faq/sampler7.jpg",
			// 				},
			// 				{
			// 					id: 8,
			// 					text: "k_dpm_2",
			// 					src: "/faq/ml_faq/sampler8.jpg",
			// 				},
			// 				{
			// 					id: 9,
			// 					text: "k_dpm_2_a",
			// 					src: "/faq/ml_faq/sampler9.jpg",
			// 				},
			// 				{
			// 					id: 10,
			// 					text: "k_euler",
			// 					src: "/faq/ml_faq/sampler10.jpg",
			// 				},
			// 				{
			// 					id: 11,
			// 					text: "k_euler_a",
			// 					src: "/faq/ml_faq/sampler11.jpg",
			// 				},
			// 				{
			// 					id: 12,
			// 					text: "k_heun",
			// 					src: "/faq/ml_faq/sampler12.jpg",
			// 				},
			// 			],
			// 		},
			// 	],
			// },
		];
	}

	if (type === "page_erase" || type === "page_expand" || type === "page_bgrem" || type === "page_pricing") {
		const faqObj = dictionary[type];
		const faq = faqObj ? faqObj["faq"] : null;
		let faqSize = faq && Object.keys(faq).length / 2;

		let arr = [];

		for (let i = 0; i < faqSize; i++) {
			arr = [...arr, { id: i, question: faq[`question_${i + 1}`], answer: faq[`answer_${i + 1}`] }];
		}

		return arr;
	}

	if (type === "picture_into_painting") {
		const questionsData = [
			{
				id: 1,
				question: "How to turn a picture into a painting?",
				answer: dictionary["In case you want to get a stunning art you just need to upload your image and AI will do the magic"],
			},
			{
				id: 2,
				question: "Is it free?",
				answer: dictionary["faq"]["answer_free"],
			},
			{
				id: 3,
				question: "How to get the best result?",
				answer: dictionary["our converter works better with landscapes"],
			},
			{
				id: 4,
				question: "Photos of which formats can I upload?",
				answer: dictionary["We support photos of image formats"],
			},
			{
				id: 5,
				question: "Can I save the painting I created?",
				answer: dictionary["faq"]["Yes, any user can download and save it"],
			},
			{
				id: 6,
				question: "What tariffs users can use this service?",
				answer: dictionary["faq"]["The service is available for users of all tariffs"],
			},
			{
				id: 7,
				question: "Where the created images can be used?",
				answer: dictionary["Your artworks will look great as the illustrations or as posts on your social media"],
			},
			{
				id: 8,
				question: "Why the result didn’t meet my expectations?",
				answer: dictionary["ai we utilize may generate inaccuracies"],
			},
		];

		return questionsData;
	}

	if (type === "image_generator") {
		const questionsData = [
			{
				id: 1,
				question: "How to get the best result?",
				answer: dictionary["faq"]["Enter a description of what you want to see"],
			},
			{
				id: 2,
				question: "In what language can I enter a query?",
				answer: dictionary["use languages"],
			},
			{
				id: 3,
				question: " How does AI generate images?",
				answer: dictionary["faq"]["ai model is trained on a huge array of image-text"],
			},
			{
				id: 4,
				question: "Is it free?",
				answer: dictionary["page_erase"]["faq"]["answer_free"],
			},
			{
				id: 5,
				question: "What styles may I use?",
				answer: dictionary["faq"]["you can use from our templates"],
			},
			{
				id: 6,
				question: "What tariffs users can use this service?",
				answer: dictionary["faq"]["The service is available for users of all tariffs"],
			},
			{
				id: 7,
				question: "Can I save the image I have created?",
				answer: dictionary["page_generator"]["faq"]["answer_save"],
			},
			{
				id: 8,
				question: "Why do I have to wait for an image to be created?",
				answer: dictionary["faq"]["When you submit your query"],
			},
			{
				id: 9,
				question: "Where can the created images and artworks be used?",
				answer: dictionary["faq"]["You can find good examples of using AI"],
			},
		];

		return questionsData;
	}

	return [];
};
